/**
 * Producción (Infomaniak / mismo dominio que el front).
 * - bela-belleza-auth: https://bela-belleza.sistemack.com/api-auth/… (rutas Laravel bajo /api/)
 * - bela-belleza-api: la URL completa la entrega el login (Base64 en localStorage); en auth: SERVICES_API_URL.
 */
export const environment = {
    production: true,
    environmentName: '',

    /** Temporal: Base64 de https://bela-belleza.sistemack.com/api-auth/public/api/ mientras se normaliza rewrite de /api-auth */
    authApiUrl: 'aHR0cHM6Ly9iZWxhLWJlbGxlemEuc2lzdGVtYWNrLmNvbS9hcGktYXV0aC9wdWJsaWMvYXBpLw==',

    // version del sistema
    version: '1.0.0',
    
    // Secret del sistema (Base64)
    secretBase64: "SDBtMzFuNzNyMW9SMi5zMHMxLjFuQzNQdDFvLkg0c1ByMzJ1UHUzc1QwMg==",
};
